module.exports = __webpack_public_path__ + "img/desc.e8ce3c5e.jpg";